import { render } from "./Relation.vue?vue&type=template&id=22de90d7&scoped=true"
import script from "./Relation.vue?vue&type=script&lang=js"
export * from "./Relation.vue?vue&type=script&lang=js"

import "./Relation.vue?vue&type=style&index=0&id=22de90d7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22de90d7"

export default script